import type { Resource } from '../../';
export const country_countries_RS: Resource = {"default":"Serbia"};
